import React from "react";
import { Box, Container, Typography, Card, CardContent, Button, Grid } from "@mui/material";
import { MessageType } from "../models/message";
import { useNavigate } from "react-router-dom";
import { messageService } from "../services/firebase/messageService";
import { User } from "firebase/auth";


export interface StaffInvitationMessageProps {
    message: MessageType;
    user: User | null;
    messages: MessageType[];
    setError: React.Dispatch<React.SetStateAction<string>>;
    setMessages: React.Dispatch<React.SetStateAction<MessageType[]>>;
}


export const RefundMessage: React.FC<StaffInvitationMessageProps> = ({
    message,
    user,
    messages,
    setError,
    setMessages
}) => {
    const navigate = useNavigate();

    const cta = async () => {

        if (!user || !user.uid) {
            setError("You must be signed in to accept invitations.");
            return;
        }
        if (!message || !message.id) {
            setError("Missing Message");
            return;
        }
        
        await messageService.updateMessage(user.uid, message.id, {isActive: false})
        setMessages(messages.filter((msg) => msg.id !== message.id)); // Remove the message from state
        navigate("/refund/management/" + message.refundId)
    }

    return (
        <Card>
            <CardContent>
                <Typography variant="h6">{message.title}</Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                    {message.description}
                </Typography>

                {message.cta === "open" && (
                    <Button
                        variant="contained"
                        sx={{background: "#162C1F", border: "1px solid #162C1F", borderRadius: "24px"}}
                        onClick={() => cta()}
                    >
                        Handle Refund
                    </Button>
                )}
            </CardContent>
        </Card>
    )
}